export default "__VITE_PUBLIC_ASSET__f8562456__"